/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface KEYSETINFO {
    version?: number;
    /**
     * Base64 encoded
     */
    kic: string;
    /**
     * Base64 encoded
     */
    kid: string;
    /**
     * Base64 encoded
     */
    kik?: string;
    counter: number;
    /**
     * Base64 encoded
     */
    enc?: string;
    /**
     * Base64 encoded
     */
    mac?: string;
    /**
     * Base64 encoded
     */
    psk: string;
    /**
     * Base64 encoded
     */
    dek?: string;
    transportKey?: string;
    transportKeyAlgorithm?: KEYSETINFO.TransportKeyAlgorithmEnum;
}
export namespace KEYSETINFO {
    export type TransportKeyAlgorithmEnum = 'TDES_CBC' | 'TDES_ECB' | 'AES_CBC' | 'AES_ECB';
    export const TransportKeyAlgorithmEnum = {
        TDESCBC: 'TDES_CBC' as TransportKeyAlgorithmEnum,
        TDESECB: 'TDES_ECB' as TransportKeyAlgorithmEnum,
        AESCBC: 'AES_CBC' as TransportKeyAlgorithmEnum,
        AESECB: 'AES_ECB' as TransportKeyAlgorithmEnum
    }
}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/model/kEYSETINFO.ts